
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M14.44 39.74v10.55M19.71 45.02H9.16"}}),_c('circle',{attrs:{"cx":"45.56","cy":"41.07","r":"1.5","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"49.93","cy":"45.44","r":"1.5","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"41.19","cy":"45.44","r":"1.5","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"45.56","cy":"49.8","r":"1.5","fill":"#241f21"}}),_c('path',{attrs:{"d":"M45.56 32.25H14.44a13.19 13.19 0 1011.83 19h7.46a13.18 13.18 0 1011.83-19zM27 42.02h6M36 32a6 6 0 10-12 0","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M30.08 26V14a6.91 6.91 0 1113.82 0 3.84 3.84 0 107.68 0V0","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    